import React, { useContext, useEffect } from 'react';
import { CMSContext } from 'context/AppContext';
import { StyledModal, CloseButton } from './Modal.style';
import CloseLineIcon from 'remixicon-react/CloseLineIcon';
import { pushPageViewEvent } from 'components/tracking/events';

interface Props {
    name: string;
    children: React.ReactElement;
    onClose: () => void;


    fullScreen?: boolean;
    transitionDuration?: number;
}

const MODAL_PARAM_KEY = 'modal';

export const getModalUrl = (name: string) => {
    const params = new URLSearchParams(window.location.search);
    params.set(MODAL_PARAM_KEY, name);
    const newUrl = `${window.location.pathname}?${params.toString()}`;
    return newUrl;
};

//The modal takes care of the display/overlay/close function, and also fires open + close events
//The contents (children) of the modal can be whatever you like
//Modal is opened by it's parent (where it is used) with a state variable (eg. {isShowingModal && <Modal...})
const Modal: React.FC<Props> = ({ name, children, onClose, fullScreen, transitionDuration }) => {
    const cms = useContext<any>(CMSContext);

    useEffect(() => {
        //append modal name as query string to url
        const newUrl = getModalUrl(name);
        
        window.history.replaceState({}, '', newUrl);
        pushPageViewEvent({lastUri: window.location.href, currentUri: newUrl, pageTitle: 'modal-' + name});

    }, []);

    const closeModal = () => {

        //remove modal name from url
        const params = new URLSearchParams(window.location.search);
        params.delete(MODAL_PARAM_KEY);
        const newUrl = `${window.location.pathname}?${params.toString()}`;

        window.history.replaceState({}, '', newUrl);
        pushPageViewEvent({lastUri: window.location.href, currentUri: newUrl, pageTitle: 'modal-' + name});

        onClose();
    }

    //Dialog always open as the parent controls the opening and closing with state
    return (<>
            <StyledModal data-modal-name={`modal-${name}`} open onClose={closeModal} fullScreen={fullScreen} transitionDuration={transitionDuration}>
                {/* Bit of an anti-pattern: clone the children and pass in the closeModalFn for use inside any of its children */}
                {/* We need this here so the modal query params in the url are managed in a single place */}
                {React.cloneElement(children, {...{closeModalFn: closeModal}})}
                <CloseButton onClick={closeModal}>
                    {cms.snippets["text-common-close"]?.text}
                    <CloseLineIcon />
                </CloseButton>
            </StyledModal>
        </>
    );
}
 
export default Modal;